import { IReactionBarSegment } from "src/components/common/aggregated-reactions-bar/types";
import { TAggregatedReactions } from "src/types/common";
import { EnumReactionColor, EnumReactionType } from "src/types/common-enum";

const REACTION_ORDER = {
    [EnumReactionType.ArticleUserSurprise]: 1,
    [EnumReactionType.ArticleUserMarketOverReaction]: 2,
    [EnumReactionType.ArticleUserPricePredictionUnderlying]: 3,
};

export const mapAggregatedReactionsToOrderedBarSegments = (aggregatedReactions: TAggregatedReactions): IReactionBarSegment[] => {
    const mappedAggregatedReactions = [...aggregatedReactions];
    return mappedAggregatedReactions
        .sort((a, b) => {
            if (REACTION_ORDER[a.reactionType] < REACTION_ORDER[b.reactionType]) {
                return -1;
            }
            return 0;
        })
        .flatMap(reaction => {
            switch (reaction.reactionType) {
                case EnumReactionType.ArticleUserSurprise:
                    return {
                        color: EnumReactionColor.Blue,
                        value: reaction.numberOfReactions,
                        weightedValue: reaction.weightedNumberOfReactions,
                    };
                case EnumReactionType.ArticleUserMarketOverReaction:
                    return {
                        color: EnumReactionColor.Yellow,
                        value: reaction.numberOfReactions,
                        weightedValue: reaction.weightedNumberOfReactions,
                    };
                case EnumReactionType.ArticleUserPricePredictionUnderlying:
                    const { numberOfReactions, positiveReactions, negativeReactions, weightedNegativeReactions, weightedPositiveReactions } =
                        reaction;
                    const neutralReactions = numberOfReactions - ((positiveReactions ?? 0) + (negativeReactions ?? 0));
                    return [
                        {
                            color: EnumReactionColor.Red,
                            value: negativeReactions,
                            weightedValue: weightedNegativeReactions,
                        },
                        {
                            color: EnumReactionColor.Grey,
                            value: neutralReactions,
                            weightedValue: neutralReactions,
                        },
                        {
                            color: EnumReactionColor.Green,
                            value: positiveReactions,
                            weightedValue: weightedPositiveReactions,
                        },
                    ] as IReactionBarSegment[];
                default:
                    return [];
            }
        });
};
